import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { REMOVE_AUTH_TOKEN } from 'root/src/shared/descriptions/endpoints/endpointIds'

export default (platform, platformId) => async (dispatch) => {
	const { error } = await dispatch(apiRequest(REMOVE_AUTH_TOKEN, { platform, platformId }))
	if (error) {
		throw error
	}
}
